// @flow
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { responsiveStateReducer } from 'redux-responsive';

import appBarReducer from './appBar';
import authReducer from './auth';
import contactCardReducer from './contactCard';
import coordinateInputDialogReducer from './coordinateInputDialog';
import dndOverlayReducer from './dndOverlay';
import drawOverlayReducer from './drawOverlay';
import errorMessageReducer from './errorMessage';
import filtersReducer from './filters';
import flagsReducer from './flags';
import geocoderReducer from './geocoder';
import hudReducer from './hud';
import mapReducer from './map';
import mapLayerDrawerReducer from './mapLayerDrawer';
import notamDetailsDialogReducer from './notamDetailsDialog';
import rtReducer from './rt';
import searchReducer from './search';
import searchResultsDialogReducer from './searchResultsDialog';
import userTemplatesReducer from './userTemplates';
import locationPermissionReducer from './locationPermission';

const rootReducer = combineReducers({
  appBar: appBarReducer,
  auth: authReducer,
  browser: responsiveStateReducer,
  coordinateInputDialog: coordinateInputDialogReducer,
  contactCard: contactCardReducer,
  dndOverlay: dndOverlayReducer,
  drawOverlay: drawOverlayReducer,
  errorMessage: errorMessageReducer,
  filters: filtersReducer,
  flags: flagsReducer,
  geocoder: geocoderReducer,
  hud: hudReducer,
  map: mapReducer,
  mapLayerDrawer: mapLayerDrawerReducer,
  notamDetailsDialog: notamDetailsDialogReducer,
  router: routerReducer,
  rt: rtReducer,
  search: searchReducer,
  searchResultsDialog: searchResultsDialogReducer,
  userTemplates: userTemplatesReducer,
  locationPermission: locationPermissionReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.js